import { NavItemKey } from '@/components/BurgerNav/BurgerNavDrawer.types';

export const DESKTOP_NAV_ITEMS_ORDER_1: NavItemKey[] = [
  'shops',
  'help',
  'forBusiness',
];

export const DESKTOP_NAV_ITEMS_ORDER_2: NavItemKey[] = [
  'aboutProject',
  'termsOfUse',
  'privacyPolicy',
  'advertisingOnSite',
];
